"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.src = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
exports.src = require("./src");
//# sourceMappingURL=index.js.map